import axios from "axios";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { basePathConfig } from "../../config";
import errorHandler from "../error/errorHandler";

// Thunks
// fetch report for overview Data
export const fetchOverviewReport = createAsyncThunk(
  "agentReport/fetch",
  async (PayloadData) => {
    try {
      const bearer_token = `Bearer ${localStorage.getItem("accessToken")}`;
      const accountID = localStorage.getItem("atua");
      if (!!bearer_token && !!accountID) {
        const config = {
          headers: {
            Authorization: bearer_token,
          },
        };
        const data = {
          account_id: accountID.toString(),
          day_label: PayloadData.dayID,
          start_date: !!PayloadData.start_date ? PayloadData.start_date : "",
          end_date: !!PayloadData.end_date ? PayloadData.end_date : "",
        };
        //console.log("fetchOverviewReport data == ", JSON.stringify(data));
        const res = await axios.post(
          `${basePathConfig.baseURL}/app/overview-reports`,
          data,
          config
        );
        // console.log(
        //   "fetchOverviewReport res.data == ",
        //   JSON.stringify(res.data)
        // );
        return await res.data.data;
      } else {
        return { message: "Unauthorized", status: 401 };
      }
    } catch (error) {
      var ErrorData = await errorHandler(error);
      return await ErrorData;
    }
  }
);
export const STATUSES = Object.freeze({
  SUCCESS: "success",
  ERROR: "error",
  LOADING: "loading",
});
export const reportOverviewSlice = createSlice({
  name: "reportOverview",
  initialState: {
    overviewReportdata: [],
    overviewStatus: STATUSES.SUCCESS,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchOverviewReport.pending, (state, action) => {
        state.overviewReportdata = [];
        state.overviewStatus = STATUSES.LOADING;
      })
      .addCase(fetchOverviewReport.fulfilled, (state, action) => {
        state.overviewReportdata = action.payload;
        state.overviewStatus = STATUSES.SUCCESS;
      })
      .addCase(fetchOverviewReport.rejected, (state, action) => {
        state.overviewReportdata = [];
        state.overviewStatus = STATUSES.ERROR;
      });
  },
});

export const { setOverviewReportdata, setOverviewStatus } =
  reportOverviewSlice.actions;
export default reportOverviewSlice.reducer;
